import React, { useState, useRef } from "react";
import { withRouter } from "react-router-dom";
import { Helmet } from "react-helmet";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import UiFormTitle from "../common/UiFormTitle";
import ProjectUsersManager from "./components/ProjectUsersManager";
import UpdateProject from "./components/UpdateProject";
import { appPageRootMinHeight } from "../appBar/appBarTheme";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      ...appPageRootMinHeight(theme),
    },
    paper: {
      minWidth: "100%",
      borderRadius: "5px",
    },
    header: {
      backgroundColor: theme.palette.primary.main,
      padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
      borderRadius: "5px 5px 0 0",
    },
    progress: {
      width: 250,
      minHeight: 40,
      margin: `${theme.spacing.unit * 2}px ${theme.spacing.unit}px`,
    },
    title: {
      color: "white",
    },
    form: {
      padding: `${theme.spacing.unit * 4}px`,
    },
    margin: {
      margin: theme.spacing.unit,
      fontWeight: 200,
    },
    label: {
      fontWeight: 200,
      display: "block",
      fontSize: 16,
    },
    sourceDonnees: {
      marginTop: theme.spacing.unit,
    },
    btnLink: {
      padding: "5px 0",
      backgroundColor: "transparent",
      textDecoration: "none",
      border: "none",
      "&:hover": {
        textDecoration: "underline",
      },
      cursor: "pointer",
      marginRight: "-10px",
    },
    error: {
      color: "red",
      paddingTop: theme.spacing.unit,
    },
  });

const Project = (props: any) => {
  const {
    classes,
    clients,
    saveProject,
    checkProjectName,
    saveUser,
    history,
    indices,
    tagLists,
    project,
    projectId,
    users,
    location: { search },
  } = props;

  const [viewMode, setViewMode] = useState<"form" | "users">(
    search.split("=")[1],
  );

  if (projectId && !project.id) return null;

  return (
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      className={classes.root}
    >
      <Helmet>
        {viewMode !== "users" && (
          <title>{project.id ? "Modifier un projet" : "Nouveau projet"}</title>
        )}
        {viewMode === "users" && (
          <title>Attribuer les utilisateurs à un projet</title>
        )}
      </Helmet>
      <Grid item lg={6} md={8}>
        <Paper elevation={2} className={classes.paper}>
          <UiFormTitle>
            {project.id
              ? `${
                  viewMode === "users" ? "Utilisateurs du projet" : "Projet"
                } ${project.name}`
              : "NOUVEAU PROJET"}
          </UiFormTitle>
          {viewMode === "users" && (
            <ProjectUsersManager
              history={history}
              projectId={project.id}
              users={users}
              saveUser={saveUser}
            />
          )}
          {viewMode !== "users" && (
            <UpdateProject
              // @ts-ignore
              history={history}
              clients={clients}
              saveProject={saveProject}
              checkProjectName={checkProjectName}
              indices={indices}
              tagLists={tagLists}
              project={project}
            />
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(withRouter(Project));
